module PortalLibs.Client.Components.DebouncedView


open Elmish
open Thoth.Elmish
open System
open Feliz

type Model<'T> =
  { BoundValue: 'T option
    Value: 'T option
    Debouncer: Debouncer.State }

type Msg<'T> =
  | Input of 'T option
  | InputChanged of 'T option
  | DebouncerSelfMsg of Debouncer.SelfMessage<Msg<'T>>

let init initVal : Model<'T> * Cmd<Msg<'T>> =
  { Value = initVal
    BoundValue = initVal
    Debouncer = Debouncer.create () },
  Cmd.none

let update interceptOpt valueChanged msg model =
  match msg with
  | DebouncerSelfMsg debouncerMsg ->
    let debouncerModel, debouncerCmd =
      Debouncer.update debouncerMsg model.Debouncer

    { model with
        Debouncer = debouncerModel },
    debouncerCmd
  | Input inputOpt ->
    let debouncerModel, debouncerCmd =
      if Option.isSome inputOpt then
        model.Debouncer
        |> Debouncer.bounce (TimeSpan.FromSeconds 1.0) "user_input" (InputChanged inputOpt)
      else
        Debouncer.create (), Cmd.none

    { model with
        BoundValue = inputOpt
        Debouncer = debouncerModel },
    Cmd.batch [
      yield Cmd.map DebouncerSelfMsg debouncerCmd
      if Option.isNone inputOpt then
        yield Cmd.ofMsg (InputChanged inputOpt)
    ]
  | InputChanged inputOpt ->
    let interceptedValue =
      match inputOpt, interceptOpt with
      | Some input, Some intercept ->
        intercept
          {| LastValue = model.Value
             Value = input |}
      | _, _ -> inputOpt

    valueChanged interceptedValue
    { model with
              Value = interceptedValue
              BoundValue = interceptedValue },
    Cmd.none


open Feliz.UseElmish

[<ReactComponent>]
let DebouncedView<'T>
  (props: {| Key: string
             Value: 'T option
             Intercept: ({| LastValue: 'T option; Value: 'T |} -> 'T option) option
             View: 'T option -> ('T option -> unit) -> ReactElement
             ValueChanged: 'T option -> unit |})
  =
  let model, dispatch =
    React.useElmish (init props.Value, update props.Intercept props.ValueChanged, [| box props.Value |])

  props.View model.BoundValue (Feliz.React.useCallback ((Input >> dispatch), [||]))
